export default function CheckIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 13 11"
      className={props.className}
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2",
      }}
    >
      <g transform="matrix(1,0,0,1,-325,-88)">
        <g id="Table-Cell-Right-Accessory-Check">
          <path
            id="checkmark"
            d="M336.519,88L329.234,95.104L326.442,92.432L325,93.903L329.191,98.006L329.209,98.006L337.982,89.441L336.519,88Z"
            style={{ fill: "rgb(0,122,255)" }}
          />
        </g>
      </g>
    </svg>
  );
}
